<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10010] p-4">
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
      <div class="sticky top-0 bg-white border-b p-4 md:p-6 flex justify-between items-center">
        <h2 class="text-xl md:text-2xl font-bold text-gray-800">Отклик на объявление</h2>
        <button
          @click="$emit('close')"
          class="text-gray-500 hover:text-gray-700 text-2xl"
        >
          ✕
        </button>
      </div>

      <div class="p-4 md:p-6 space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Ваше сообщение
          </label>
          <textarea
            v-model="form.message"
            placeholder="Расскажите о себе, почему вы заинтересованы в этом объявлении..."
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 resize-none"
            rows="5"
          ></textarea>
          <p class="text-xs text-gray-500 mt-1">Минимум 10 символов</p>
        </div>

        <div v-if="error" class="bg-red-50 border border-red-200 rounded-lg p-3">
          <p class="text-sm text-red-700">{{ error }}</p>
        </div>

        <div v-if="loading" class="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <p class="text-sm text-blue-700">Отправка отклика...</p>
        </div>
      </div>

      <div class="sticky bottom-0 bg-gray-50 border-t p-4 md:p-6 flex gap-3">
        <button
          @click="$emit('close')"
          class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition font-medium"
          :disabled="loading"
        >
          Отмена
        </button>
        <button
          @click="submitResponse"
          class="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition font-medium"
          :disabled="loading || !form.message.trim()"
        >
          {{ loading ? 'Отправка...' : 'Отправить отклик' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import axios from 'axios';
import { API_ANNOUNCEMENT_RESPONSES, API_RESPONSE_MESSAGES, HEADERS_TOKEN_JSON } from '@/const/uri';

export default {
  name: 'ResponseCreateModal',
  emits: ['close', 'success'],
  props: {
    announcementId: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const form = ref({
      message: '',
    });
    const loading = ref(false);
    const error = ref('');

    const submitResponse = async () => {
      // Validation
      if (!form.value.message.trim()) {
        error.value = 'Пожалуйста, напишите сообщение';
        return;
      }

      if (form.value.message.trim().length < 10) {
        error.value = 'Сообщение должно содержать минимум 10 символов';
        return;
      }

      loading.value = true;
      error.value = '';

      try {
        const responseRes = await axios.post(
          `${API_ANNOUNCEMENT_RESPONSES.create}`,
          {
            announcement: props.announcementId,
            status: 'new',
          },
          { headers: HEADERS_TOKEN_JSON() }
        );

        const responseId = responseRes.data?.data?.data?.id;

        if (!responseId) {
          console.error('Response structure:', responseRes.data);
          throw new Error('Response ID not found in server response');
        }
        await axios.post(
          `${API_RESPONSE_MESSAGES.create}`,
          {
            response: responseId,
            message: form.value.message,
          },
          { headers: HEADERS_TOKEN_JSON() }
        );
        emit('success');
      } catch (err) {
        console.error('Error submitting response:', err);
        const errorData = err.response?.data;
        if (errorData?.errors?.non_field_errors?.[0]?.includes('уника')) {
          error.value = 'Вы уже оставили отклик на это объявление. Проверьте раздел "Отклики" в личном кабинете.';
        } else if (errorData?.errors?.non_field_errors?.[0]) {
          error.value = errorData.errors.non_field_errors[0];
        } else if (errorData?.errors) {
          const firstError = Object.values(errorData.errors)[0];
          error.value = Array.isArray(firstError) ? firstError[0] : firstError;
        } else if (err.response?.status === 400) {
          error.value = 'Ошибка при заполнении формы. Проверьте данные.';
        } else {
          error.value = 'Ошибка при отправке отклика. Попробуйте позже.';
        }
      } finally {
        loading.value = false;
      }
    };

    return {
      form,
      loading,
      error,
      submitResponse,
    };
  },
};
</script>

<style scoped>
textarea {
  font-family: inherit;
}

textarea:disabled {
  background-color: #f3f4f6;
  cursor: not-allowed;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
